import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as func from "../../common/athleteCommon/FunctionCalls";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const SurgeryProfile: React.FC<Props> = ({ formData, onChange }) => {

    // const surgeryCatgList = [{ surgCatgId: 1, surgCatgName: "Orthopedic" }, { surgCatgId: 2, surgCatgName: "Cardiovascular" }, { surgCatgId: 3, surgCatgName: "Neurological" }, { surgCatgId: 4, surgCatgName: "General surgery" }, { surgCatgId: 5, surgCatgName: "Other" }]
    // const bdyRgnList = [{ bdyRgnId: 1, bdyRgnName: "Head" }, { bdyRgnId: 2, bdyRgnName: "Face" }, { bdyRgnId: 3, bdyRgnName: "Cervical spine/neck" }, { bdyRgnId: 4, bdyRgnName: "Shoulder" }, { bdyRgnId: 5, bdyRgnName: "Upper Arm" }, { bdyRgnId: 6, bdyRgnName: "Elbow" },
    // { bdyRgnId: 7, bdyRgnName: "Forearm" }, { bdyRgnId: 8, bdyRgnName: "Wrist" }, { bdyRgnId: 9, bdyRgnName: "Hand/Fingers" }, { bdyRgnId: 10, bdyRgnName: "Thoracic spine" }, { bdyRgnId: 11, bdyRgnName: "Lumbar spine" }, { bdyRgnId: 12, bdyRgnName: "Pelvis" }, { bdyRgnId: 13, bdyRgnName: "Hip" },
    // { bdyRgnId: 14, bdyRgnName: "Thigh" }, { bdyRgnId: 15, bdyRgnName: "Knee" }, { bdyRgnId: 16, bdyRgnName: "Lower Leg" }, { bdyRgnId: 17, bdyRgnName: "Ankle" }, { bdyRgnId: 18, bdyRgnName: "Foot/toes" }]
    // const rehabList = [{ rehabId: 1, rehabName: "1-6 days" }, { rehabId: 2, rehabName: "1-3 weeks" }, { rehabId: 3, rehabName: "3-6 weeks" }, { rehabId: 4, rehabName: "More than 6 weeks" }]

    const [surgeryCatgList, setSurgeryCatgList] = useState<any[]>([]);
    const [bdyRgnList, setBdyRgnList] = useState<any[]>([]);
    const [rehabList, setRehabList] = useState<any[]>([]);

    useEffect(() => {
        async function getSurgProfile() {
            const surgResponse = await func.surgeryCategory(null);
            setSurgeryCatgList(Array.isArray(surgResponse) ? surgResponse : []);
            const bdyResponse = await func.bodyRegion(null);
            setBdyRgnList(Array.isArray(bdyResponse) ? bdyResponse : []);
            const rehabResponse = await func.rehabilitationDuration(null);
            setRehabList(Array.isArray(rehabResponse) ? rehabResponse : []);
        }
        getSurgProfile();
    }, [])

    const handleSelectChange = (name: string) =>
        (option: any) => {
            const value = Array.isArray(option)
                ? option.map(o => o.value)
                : option?.value ?? "";

            onChange({
                target: { name, value }
            } as React.ChangeEvent<HTMLInputElement>);
        };

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">

                    <div className="row">
                        <div className="col-lg-4">
                            <h4>Is there no Surgery history?</h4>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-check form-switch d-flex align-items-center justify-content-start">
                                <input
                                    className="form-check-input text-end"
                                    type="checkbox"
                                    checked={formData.noHistory === '1'}
                                    name="noHistory"
                                    // onChange={onChange}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: "noHistory",
                                                value: e.target.checked ? "1" : "0"
                                            }
                                        } as React.ChangeEvent<HTMLInputElement>)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    {(formData.noHistory != "1") ?
                        <>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">Date of Surgery</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="dateOfSurgery"
                                        value={formData.dateOfSurgery}
                                        onChange={onChange}
                                        placeholder="Enter Date of surgery" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Category</label>
                                    <Select
                                        value={surgeryCatgList.find(ctg => ctg.surgeryCategoryId === formData.category) ? {
                                            value: formData.category,
                                            label: surgeryCatgList.find(ctg => ctg.surgeryCategoryId === formData.category)?.name
                                        } : null}
                                        onChange={handleSelectChange("category")}
                                        placeholder="Select Category"
                                        options={surgeryCatgList.map(ctg => ({
                                            value: ctg.surgeryCategoryId,
                                            label: ctg.name
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Body Region</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(bdyRgnList)
                                            ? bdyRgnList
                                                .filter(bdy => formData.bodyRegion.includes(bdy.bodyRegionId))
                                                .map(bdy => ({
                                                    value: bdy.bodyRegionId,
                                                    label: bdy.name
                                                }))
                                            : []
                                        }
                                        onChange={handleSelectChange("bodyRegion")}
                                        options={Array.isArray(bdyRgnList)
                                            ? bdyRgnList.map(bdy => ({
                                                value: bdy.bodyRegionId,
                                                label: bdy.name
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Procedure Summary</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="procedureSummary"
                                        value={formData.procedureSummary}
                                        onChange={onChange}
                                        placeholder="Enter Procedure Summary" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Complications (if any)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="complicationsIfAny"
                                        value={formData.complicationsIfAny}
                                        onChange={onChange}
                                        placeholder="Enter Complications" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Rehabilitation duration</label>
                                    <Select
                                        value={rehabList.find(rehab => rehab.rehabilitationDurationId === formData.rehabilitationDuration) ? {
                                            value: formData.rehabilitationDuration,
                                            label: rehabList.find(rehab => rehab.rehabilitationDurationId === formData.rehabilitationDuration)?.name
                                        } : null}
                                        required
                                        onChange={handleSelectChange("rehabilitationDuration")}
                                        placeholder="Select Rehabilitation Duration"
                                        options={rehabList.map(rehab => ({
                                            value: rehab.rehabilitationDurationId,
                                            label: rehab.name
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                        </> : null}
                </div>
            </div>
        </>
    );
};

export default SurgeryProfile;